import { communityData } from "../../helper/constant";
import { useParams } from "react-router-dom";
import { MdLabelImportantOutline } from "react-icons/md";

const PlayerPortfolio = ({ data }) => {
  console.log("data", data);
  const organisationData = [
    { club: data?.clubOrganization, role: data?.role },
    { club: data?.clubOrganization2, role: data?.role2 },
    { club: data?.clubOrganization3, role: data?.role3 },
    { club: data?.clubOrganization4, role: data?.role4 },
    { club: data?.clubOrganization5, role: data?.role5 },
  ];
  return (
    <div className="bg-gradient-to-br from-white to-[#2BACE215] rounded-lg md:shadow-2xl md:border border-[#2BACE240] overflow-hidden mt-4 md:p-8 p-0">
      <div className="flex items-center gap-3 mb-5">
        <div className="bg-[#2BACE240] p-2 rounded-lg">
          <MdLabelImportantOutline className="text-[#2BACE2]" size={20} />
        </div>
        <div>
          <h2 className="md:text-2xl text-xl font-semibold text-gray-700">
            Portfolio
          </h2>
          <p className="text-slate-500 text-sm">
            Professional profile and affiliations
          </p>
        </div>
      </div>

      {/* Bio/Profile Section */}
      <div className="my-8">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-gradient-to-b from-[#2BACE2] to-[#1e9dcc] rounded-full"></div>
          <h3 className="text-xl font-bold text-slate-800">Bio/Profile</h3>
        </div>

        <div className="relative group overflow-hidden rounded-xl">
          <div className="absolute inset-0 bg-gradient-to-br from-[#2BACE230] via-[#2BACE220] to-[#2BACE210] blur-xl"></div>
          <div className="relative bg-white/80 backdrop-blur-sm md:p-6 p-3 rounded-xl border border-[#2BACE250] shadow-lg">
            <div className="flex items-start md:gap-3 gap-2">
              <div className="mt-1">
                <svg
                  className="w-5 h-5 text-[#2BACE2]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-slate-700 mb-2 flex items-center gap-2">
                  <span>Description</span>
                  <span className="text-xs text-[#2BACE2] bg-[#2BACE215] px-2 py-0.5 rounded-full">
                    About
                  </span>
                </h4>
                {data?.portfolio ? (
                  <p className="text-slate-700 text-md leading-relaxed">
                    {data?.portfolio}
                  </p>
                ) : (
                  <div className="text-center py-4">
                    <p className="text-slate-500 text-sm">
                      No description available
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Organizations Section */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-gradient-to-b from-[#2BACE2] to-[#1e9dcc] rounded-full"></div>
          <h3 className="text-xl font-bold text-slate-800">
            Primary Club / Organization
          </h3>
        </div>

        <div className="relative group overflow-hidden rounded-xl">
          <div className="absolute inset-0 bg-gradient-to-br from-[#2BACE230] via-[#2BACE220] to-[#2BACE210] blur-xl"></div>
          <div className="relative bg-white/80 backdrop-blur-sm">
            {organisationData?.some((item) => item?.club) > 0 ? (
              <div className="grid lg:grid-cols-3 grid-cols-1 gap-4">
                {organisationData?.map((item, index) => {
                  if (item?.club || item?.role) {
                    return (
                      <div
                        key={index}
                        className="group/card relative bg-gradient-to-br from-white to-[#2BACE210] border border-[#2BACE240] rounded-xl p-5 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
                      >
                        {/* Decorative elements */}
                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-[#2BACE220] to-[#2BACE210] rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>

                        {/* Organization Badge */}
                        <div className="inline-flex mb-4 items-center gap-2 bg-gradient-to-r from-[#2BACE2] to-[#1e9dcc] text-white px-3 py-1.5 rounded-full shadow-md text-xs font-semibold">
                          <svg
                            className="w-3.5 h-3.5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span>Organization #{index + 1}</span>
                        </div>

                        {/* Club/Organization */}
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-8 h-8 bg-gradient-to-br from-[#2BACE220] to-[#2BACE230] rounded-lg flex items-center justify-center">
                            <svg
                              className="w-4 h-4 text-[#2BACE2]"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                              />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <p className="text-xs text-[#2BACE2] font-semibold">
                              Club/Organization
                            </p>
                            <p className="text-slate-500 font-medium text-sm">
                              {item.club}
                            </p>
                          </div>
                        </div>

                        {/* Role */}
                        <div className="flex items-start gap-3">
                          <div className="w-8 h-8 bg-gradient-to-br from-[#2BACE220] to-[#2BACE230] rounded-lg flex items-center justify-center">
                            <svg
                              className="w-4 h-4 text-[#1e9dcc]"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                              />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <p className="text-xs text-[#1e9dcc] font-semibold">
                              Role
                            </p>
                            <p className="text-slate-500 font-medium text-sm">
                              {item.role}
                            </p>
                          </div>
                        </div>

                        {/* Hover effect line */}
                        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-[#2BACE2] to-[#1e9dcc] transform scale-x-0 group-hover/card:scale-x-100 transition-transform duration-300 origin-left"></div>
                      </div>
                    );
                  }
                })}
              </div>
            ) : (
              <div className="text-center py-8">
                <div className="bg-[#2BACE215] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-[#2BACE2]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <p className="text-slate-600 font-medium">
                  No Organizations Found
                </p>
                <p className="text-slate-500 text-sm mt-1">
                  Join a club to see it here
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerPortfolio;
